// T3-B sponsored motif (PR 4, 2026-05-07): sponsored_motifs 管理用 MobX store。

import { SponsoredMotifApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class SponsoredMotifStore extends BaseStore {
    motifs: any[] = [];
    motif: any = null;
    api: SponsoredMotifApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            motifs: observable,
            motif: observable,
            listByCampaign: flow.bound,
            getById: flow.bound,
            create: flow.bound,
            update: flow.bound,
            remove: flow.bound
        });
        this.api = new SponsoredMotifApi();
    }

    *listByCampaign(campaignId: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.listByCampaign, campaignId);
            if (res?.ok) {
                this.motifs = res.data?.items ?? [];
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *getById(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getById, id);
            if (res?.ok) {
                this.motif = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *create(payload: { campaignId: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.create, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *update(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, id);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
